import React from "react";
import { T } from "../../constants/theme";

const SectionTitle = ({ children, style = {} }) => (
  <div
    style={{
      fontSize: "11px",
      color: T.muted,
      fontWeight: 700,
      marginBottom: "8px",
      marginTop: "4px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      ...style,
    }}
  >
    {children}
  </div>
);

export default SectionTitle;
